import React from "react";
import { useEffect, useState, useMemo } from "react";
import LeagueMatches from "./LeagueMatches";
import { transformDataByRound } from "../../../utils/generalLiveCenter";
import CricketLeagueMatches from "../../cricket/league/CricketLeagueMatches";
import { loadStyles } from "../../../utils/cssLoader";

const LeagueWrapper = ({
  sport,
  data,
  loadCSS,
  baseUrl,
  setDataId,
  setDataType,
  setHead,
  dataClient,
  websiteBaseUrl,
  dataPath,
  title,
  matchType = "league",
  updatedData = false,
  difference,
}) => {
  const [clientData, setClientData] = useState([]);

  useEffect(() => {
    if (!dataClient) return;

    const container = document.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || []);
    } catch (error) {
      console.error("Failed to parse client data:", error);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("livematchdetail");
    }
  }, [loadCSS]);

  const finalData = useMemo(
    () => (dataClient ? clientData : data),
    [dataClient, clientData, data]
  );

  let resp;
  if (updatedData) {
    resp = transformDataByRound(finalData);
    resp = resp?.data;
  } else {
    resp = finalData;
  }


  return (
    <>
      {title && <h1>{title}</h1>}
      <React.Fragment>
        {sport === "football" || sport === "rugby" ? (
          <LeagueMatches
            finalData={resp}
            matchType={matchType}
            loadCSS={loadCSS}
            sport={sport}
            baseUrl={baseUrl}
            setDataId={setDataId}
            setDataType={setDataType}
            setHead={setHead}
            websiteBaseUrl={websiteBaseUrl}
            dataPath={dataPath}
            updatedData={updatedData}
            dataClient={dataClient}
            difference={difference}
          />
        ) : (
          <>
            <CricketLeagueMatches
              finalData={resp}
              matchType={matchType}
              sport={sport}
              baseUrl={baseUrl}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              updatedData={true}
              dataClient={dataClient}
              tournamentListing={matchType !== "team" ? "tournamentListing" : "team"}
              difference={difference}
            />
          </>
        )}
      </React.Fragment>
    </>
  );
};

export default LeagueWrapper;
